import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { BorderedBottomTabs, CustomNavLink, NavItem } from '@spark/ui-components/components/Tabs';
import { Nav } from 'react-bootstrap';
import { notification } from '@spark/ui-components/utils/notification';
import { useAcompanhamento } from '../hooks/useAcompanhamento';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import styled from 'styled-components'; // Importar os componentes das tabs

import DetalhesTab from './components/Tabs/DetalhesTab';
import MensagensTab from './components/Tabs/MensagensTab';

const DetalhesAcompanhamentos = () => {
  const {
    t
  } = useTranslation('common');
  const location = useLocation();
  const history = useHistory();
  const {
    id
  } = useParams();
  const [modalVisible, setModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('detalhes');
  const [refreshKey, setRefreshKey] = useState(0); // Hook para gerenciar o acompanhamento

  const {
    data: acompanhamento,
    loading: loadingAcompanhamento,
    deleteAcompanhamento
  } = useAcompanhamento(id); // Detectar se está no modo de edição ou visualização

  const isEditMode = location.pathname.includes('/editar/');
  const isViewMode = location.pathname.includes('/detalhes/'); // Obter informações sobre a origem da navegação

  const returnPath = location.state?.returnPath || '/pages/acompanhamentos';
  const fromCarga = location.state?.fromCarga || false;
  const cargaId = location.state?.cargaId; // Função para refresh geral

  const handleRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  const handleVoltar = () => {
    history.goBack();
  };

  const handleEditar = () => {
    history.push(`/pages/acompanhamentos/editar/${id}`, {
      returnPath,
      fromCarga,
      cargaId
    });
  };

  const handleDelete = async () => {
    try {
      await deleteAcompanhamento(id);
      history.push(returnPath);
    } catch (err) {
      console.error('Erro ao deletar acompanhamento:', err); // Erro já tratado pelo hook
    } finally {
      setModalVisible(false);
    }
  };

  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Acompanhamentos',
          path: '/pages/acompanhamentos'
        }, {
          name: 'Detalhes'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              {
              /* Botões de ação */
            }
              <ButtonContainer>
                {!isEditMode && <>
                    <ButtonWithLoading variant="primary" onClick={handleEditar}>
                      Editar
                    </ButtonWithLoading>
                    <ButtonWithLoading variant="outline-danger" onClick={() => setModalVisible(true)} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                      <i className="fas fa-trash" style={{
                    fontSize: '16px'
                  }}></i>
                      Excluir
                    </ButtonWithLoading>
                  </>}
                <ButtonWithLoading variant="secondary" onClick={handleVoltar}>
                  Voltar
                </ButtonWithLoading>
              </ButtonContainer>

              {
              /* Sistema de Tabs */
            }
              <Row>
                <Col md={12}>
                  <BorderedBottomTabs className="mb-3">
                    <Nav variant="tabs" className="nav-tabs">
                      <NavItem>
                        <CustomNavLink active={activeTab === 'detalhes'} onClick={() => setActiveTab('detalhes')}>
                          <span className="tab-text">Detalhes</span>
                        </CustomNavLink>
                      </NavItem>
                      <NavItem>
                        <CustomNavLink active={activeTab === 'mensagens'} onClick={() => setActiveTab('mensagens')}>
                          <span className="tab-text">Mensagens</span>
                        </CustomNavLink>
                      </NavItem>
                    </Nav>
                  </BorderedBottomTabs>
                </Col>
              </Row>

              {
              /* Conteúdo das Tabs */
            }
              {activeTab === 'detalhes' && <Row>
                  <Col md={12}>
                    <DetalhesTab acompanhamentoId={id} onRefresh={handleRefresh} key={refreshKey} />
                  </Col>
                </Row>}

              {activeTab === 'mensagens' && <Row>
                  <Col md={12}>
                    <div style={{
                  padding: '20px 0'
                }}>
                      <MensagensTab acompanhamentoId={id} onRefresh={handleRefresh} key={refreshKey} />
                    </div>
                  </Col>
                </Row>}

            </CardBody>
          </Card>
        </Col>
      </Row>

      {
      /* Modal de confirmação de exclusão */
    }
      <ConfirmDeleteModal show={modalVisible} onClose={() => setModalVisible(false)} onConfirm={handleDelete} loading={loadingAcompanhamento} title="Excluir Acompanhamento" message={`Tem certeza que deseja excluir o acompanhamento "${acompanhamento?.Titulo || 'este item'}"?`} />
    </Container>;
};

export default DetalhesAcompanhamentos; // Estilos

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
`;
